import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2974f4ec&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=2974f4ec&prod&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=2974f4ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974f4ec",
  null
  
)

export default component.exports